(() => {
  'use strict';
  const init = (scope = document) => {
    const heroes = [...scope.querySelectorAll('[data-magic-hero]')];
    if (scope.matches?.('[data-magic-hero]')) heroes.unshift(scope);
    heroes.forEach((hero) => {
      if (hero.dataset.magicReady) return;
      hero.dataset.magicReady = 'true';
      const select = hero.querySelector('[data-magic-variant]');
      const image = hero.querySelector('.cf-magic-product-image');
      const button = hero.querySelector('[data-magic-add]');
      const sync = (updateUrl) => {
        const option = select.selectedOptions[0];
        hero.querySelector('[data-magic-price]').textContent = option.dataset.price;
        hero.querySelector('[data-magic-help]').textContent = option.dataset.help;
        hero.querySelector('[data-magic-image-label]').textContent = option.dataset.title;
        hero.querySelector('[data-magic-bar-variant]').textContent = option.dataset.title;
        button.disabled = option.dataset.available !== 'true';
        button.textContent = button.disabled ? button.dataset.sold : button.dataset.add;
        if (image && option.dataset.image) {
          image.removeAttribute('srcset');
          image.src = option.dataset.image;
          image.alt = option.dataset.alt;
        }
        if (updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', option.value);
          window.history.replaceState({}, '', url);
        }
      };
      select.addEventListener('change', () => sync(true));
      hero.magicSync = sync;
      const bar = hero.querySelector('[data-magic-bar]');
      const form = hero.querySelector('.cf-magic-form');
      const footer = document.querySelector('footer.footer');
      let frame = 0;
      const updateBar = () => {
        frame = 0;
        bar.hidden = form.getBoundingClientRect().bottom >= 0 ||
          Boolean(footer && footer.getBoundingClientRect().top < window.innerHeight);
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(updateBar); };
      window.addEventListener('scroll', schedule, {passive: true});
      window.addEventListener('resize', schedule);
      updateBar();
      hero.magicCleanup = () => {
        window.removeEventListener('scroll', schedule);
        window.removeEventListener('resize', schedule);
        cancelAnimationFrame(frame);
      };
    });
  };
  if (!window.cfMagicSpongeBound) {
    window.cfMagicSpongeBound = true;
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-magic-hero]').forEach((hero) => hero.magicCleanup?.());
    });
    window.addEventListener('pageshow', () => {
      init();
      document.querySelectorAll('[data-magic-hero]').forEach((hero) => hero.magicSync?.(false));
    });
  }
  init();
})();
